module.exports = __webpack_public_path__ + "img/21.aa0277cd.jpg";